export const MAX_MEDIA_CONFIG = {
  google: 1,
  tiktok: 1,
  video: {
    twitter: 1,
    facebook: 1,
    instagram: 1,
    linkedin: 1,
    pinterest: 1
  },
  gif: {
    twitter: 1,
    facebook: 1,
    instagram: 0,
    linkedin: 1,
    pinterest: 1
  },
  image: {
    twitter: 4,
    facebook: 10,
    instagram: 10,
    linkedin: 20,
    pinterest: 1
  }
};
